import '@testing-library/jest-dom';
import { render, screen, fireEvent } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import { TextArea } from './TextArea';

describe('TextArea', () => {
  it('should render correctly with label', () => {
    render(<TextArea onChange={jest.fn()} label="Test Label" />);
    expect(screen.getByText('Test Label')).toBeInTheDocument();
  });

  it('should call onChange when text is entered', () => {
    const handleChange = jest.fn();
    render(<TextArea onChange={handleChange} />);

    const textarea = screen.getByRole('textbox');
    fireEvent.input(textarea, { target: { value: 'Hello' } });
    expect(handleChange).toHaveBeenCalledWith('Hello');
  });

  it('should update character count', () => {
    render(<TextArea onChange={jest.fn()} label="Test" maxCharacters={10} />);

    const textarea = screen.getByRole('textbox');
    fireEvent.input(textarea, { target: { value: 'Test' } });

    expect(screen.getByText('4')).toBeInTheDocument();
    expect(screen.getByText('/ 10')).toBeInTheDocument();
  });

  it('should not exceed max characters limit', async () => {
    const handleChange = jest.fn();
    render(<TextArea onChange={handleChange} maxCharacters={5} />);

    const textarea = screen.getByRole('textbox');

    await userEvent.type(textarea, 'ExceedsLimit');

    expect(handleChange).toHaveBeenCalled();
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    expect(handleChange.mock.calls[handleChange.mock.calls.length - 1][0].length).toBe(5);
  });
});
